module.exports = __webpack_public_path__ + "img/notifications.27773eaa.svg";